import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage } from '../components/profile/SettingsPage';

// Index route for /profile/settings — renders the settings dashboard
export const Route = createFileRoute('/profile/settings/')({
  component: SettingsPage,
});
